// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { activeCarListSelector } from '../../../selectors/carSelectors';
import Cars from '../Cars';
import type { Props } from '../Cars';

type OwnProps = $ReadOnly<{
    showForm: () => void,
    showMessages: () => void,
    now: Date
}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    return {
        cars: activeCarListSelector(state, { now: props.now })
    };
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(Cars);